import { FC, ReactNode, useEffect, useRef } from "react";
import axios from "axios";
import { useCustomKeycloak } from "../hooks/useCustomKeycloak";
import { SelectEntityPage } from "../pages/SelectEntityPage/SelectEntityPage";
import { useAppSelector } from "../store";
import { Navigate } from "react-router-dom";
import { RoutesReact } from "../constants/routes";

const BASE_URL = process.env.REACT_APP_BASE_URL || "";

function getBrowserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Rome";
  } catch {
    return "Europe/Rome";
  }
}

export const SelectedEntityGuard: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { keycloak } = useCustomKeycloak();
  const selectedEntity = useAppSelector((st) => st.me.selectedEntity);
  const syncedRef = useRef(false);

  // Sincronizza user.timezone col browser una volta sola dopo che l'entity
  // è stata selezionata. Prima la call era in loginUser ma il backend guard
  // CheckDirectorIdGuard richiede entity-id header → 401. Axios interceptor
  // inietta entity-id solo se selectedEntity presente.
  //
  // Skip se l'entity selezionata è un Director: l'endpoint `/users/keycloak`
  // è protetto da `OnlyUserGuard` lato backend e accetta solo profili user
  // (athlete/coach/administrator). Director non ha campo `type`.
  useEffect(() => {
    if (!selectedEntity || syncedRef.current) return;
    const entityType = (selectedEntity as { type?: string }).type;
    if (!entityType) return;
    syncedRef.current = true;
    const tz = getBrowserTimezone();
    axios.patch(`${BASE_URL}/users/keycloak`, { timezone: tz }).catch(() => {});
  }, [selectedEntity]);

  if (!keycloak.authenticated) {
    return <Navigate to={RoutesReact.DIRECTOR_LOGIN} />;
  }
  if (!selectedEntity) {
    return <SelectEntityPage />;
  }

  return <>{children}</>;
};
